import { Result } from "@/types/result";
import { fetcher } from "@/utils/fetcher";
import BaseService from "./baseService";

/**
 * User サービス
 */
export default class UserService extends BaseService {
	/**
	 * ユーザーを登録します。
	 * @param body リクエストボディ
	 * @returns ユーザー
	 */
	async Register(body: object): Promise<Result<null, Error>> {
		return await fetcher.post(this.url(`/auth/register`), body);
	}

	/**
	 * ログインします。
	 * @param body リクエストボディ
	 * @returns ユーザー
	 */
	async Login(body: object): Promise<Result<null, Error>> {
		return await fetcher.post(this.url(`/auth/login`), body);
	}

	/**
	 * ソーシャルアカウントでログインします。
	 * @param body リクエストボディ
	 * @returns ユーザー
	 */
	async SocialLogin(body: object): Promise<Result<null, Error>> {
		return await fetcher.post(this.url(`/auth/social-login`), body);
	}

	/**
	 * ログアウトします。
	 * @returns ユーザー
	 */
	async Logout(): Promise<Result<null, Error>> {
		return await fetcher.post(this.url(`/auth/logout`));
	}
}
